import axios, { AxiosResponse } from 'axios';

const Axios = axios.create({
    baseURL: process.env.REACT_APP_API_ROOT,
    withCredentials: true,
});

Axios.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;

        if (error.response.status === 401) {
            const refreshToken = localStorage.getItem('refresh_token');
            if (refreshToken === null) {
                localStorage.removeItem('expires_at');
                window.location.reload();
            }
            return Axios.post('/token/refresh', { refresh: refreshToken })
            .then((res: AxiosResponse<any> ) => {
                localStorage.setItem('access_token', res.data.access);
                Axios.defaults.headers['Authorization'] = `Bearer ${res.data.access}`;
                originalRequest.headers['Authorization'] = `Bearer ${res.data.access}`;

                return axios(originalRequest);
            }).catch(err => {
                console.error(err);
            });
        }
        return Promise.reject(error);
    }
)

export default Axios;